import React, { useCallback } from 'react'
import { t } from 'i18next'
import { CSVLink } from 'react-csv'
import GlSpacer from '../../../share/GlSpacer'
import { ReactComponent as CrossIcon } from '../../../../assets/icons/app/cross.icon.svg'
import { ReactComponent as DownloadIcon } from '../../../../assets/icons/download.icon.svg'
import AnalyticDetailsTable from './table/AnalyticDetailsTable'
import { useAppDispatch, useAppSelector } from '../../../../store/hooks'
import {
  selectAnalyticDetailsStateAnalyticDetailsBooksInput,
  selectAnalyticDetailsStateAnalyticDetailsBooksOutput,
  selectAnalyticDetailsStateBookDetailsSelected,
} from '../../../../store/getters/analytics-details/analytic-details-v2.getters'
import { WorkMirrorBookInterface } from '../../../../core/interface/report/work-mirror-book.interface'
import { analyticDetailsV2StateGetBookDetailsData } from '../../../../store/actions/analytics-details/analytic-details-v2.actions'
import { clilReferencesConfig } from '../../../../core/config/clil-references.config'
import { sanitizeStringForFileSafeName } from '../../../../core/utils/filename-sanitizer.utils'

const WorkMirrorListCard = ({
  bookEanIdHovered,
  handleCloseList,
}: {
  bookEanIdHovered: number | null
  handleCloseList: () => void
}) => {
  const onClickCloseButton = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    handleCloseList()
  }

  const booksInput = useAppSelector(
    selectAnalyticDetailsStateAnalyticDetailsBooksInput,
  )

  const booksOutput = useAppSelector(
    selectAnalyticDetailsStateAnalyticDetailsBooksOutput,
  )

  const dispatch = useAppDispatch()
  const bookDetailsSelected = useAppSelector(
    selectAnalyticDetailsStateBookDetailsSelected,
  )
  const handleBookSelected = useCallback(
    (bookDetails: WorkMirrorBookInterface | null) => {
      void dispatch(analyticDetailsV2StateGetBookDetailsData({ bookDetails }))
    },
    [],
  )

  let index = 0
  const csvData = booksOutput.map((output) => {
    index += 1
    return {
      rank: index,
      proximity: Math.round((1 - (output.distance ?? 0)) * 1000) / 10,
      title: output.book.title,
      author: output.book.authors?.[0],
      clil1: clilReferencesConfig[output.book.clil1 ?? 0]?.libelle,
    }
  })

  return (
    <div className="flex flex-col basis-1/3 gap-4">
      <div className="flex flex-row items-center justify-between gap-2">
        <GlSpacer />
        <button
          type="button"
          className="flex flex-row items-center justify-center gap-2 p-2 bg-[#e9e9e9] rounded"
        >
          <DownloadIcon className="w-4 h-4" />
          <CSVLink
            filename={`OEuvres.miroirs.Gleeph.de.${booksInput
              .map((book) => sanitizeStringForFileSafeName(book.title ?? ''))
              .join('.')}.csv`}
            data={csvData}
            style={{ textDecoration: 'none', color: 'inherit' }}
          >
            <span>{t('downloadResults')}</span>
          </CSVLink>
        </button>
        <button
          type="button"
          className="flex flex-row items-center justify-center gap-2 p-2 bg-[#e9e9e9] rounded"
          onClick={onClickCloseButton}
        >
          <CrossIcon className="w-4 h-4" />
          <span>Fermer</span>
        </button>
      </div>
      <div className="relative flex-auto flex flex-col rounded-xl bg-white">
        <AnalyticDetailsTable
          bookDetailsSelected={bookDetailsSelected}
          booksOutput={booksOutput}
          isLoadingReloadOutput={false}
          handleBookSelected={handleBookSelected}
          bookEanIdHovered={bookEanIdHovered}
        />
      </div>
    </div>
  )
}

export default WorkMirrorListCard
